import {prop} from 'ramda';

import {DashboardTileId} from '../types/DashboardTileId';
import {DASHBOARD_TILE_CATALOGUE} from './dashboardTileCatalogue';

export function isDashboardTileResizable(tileId: DashboardTileId): boolean {
  return prop(tileId, DASHBOARD_TILE_CATALOGUE).sizes.length > 1;
}
